jQuery($ => {
	const infoBarLocalstorageKey = 'vp-info-bar-closed';

	if ($('body > .info-bar').length === 0) {
		return;
	}

	$('.info-bar').each(function () {
		const $infoBar = $(this);
		if ($infoBar.find('button.close').length === 0) {
			showInfoBar($infoBar);
		} else {
			const hash = $infoBar.attr('data-hash');
			const closedInfoBarHashes = getClosedInfoBarHashes();
			if (!closedInfoBarHashes.includes(hash)) {
				showInfoBar($infoBar);
			}
		}
	});

	$('.info-bar .close').click(function () {
		$(this).closest('.info-bar').slideUp(200, function () {
			const hash = $(this).attr('data-hash');
			const closedInfoBarHashes = getClosedInfoBarHashes();
			closedInfoBarHashes.push(hash);
			setClosedInfoBarHashes(closedInfoBarHashes);
			$(this).remove();
		});
		$(document.body).removeClass('with-info-bar');
	});

	function showInfoBar($infoBar) {
		$(document.body).addClass('with-info-bar');
		$infoBar.slideDown(200);
	}

	function getClosedInfoBarHashes() {
		return JSON.parse(localStorage.getItem(infoBarLocalstorageKey) || '[]')
	}

	function setClosedInfoBarHashes(hashes) {
		localStorage.setItem(infoBarLocalstorageKey, JSON.stringify(hashes));
	}
});
